import { render, staticRenderFns } from "./GallerySection.vue?vue&type=template&id=f2255040&scoped=true&"
import script from "./GallerySection.vue?vue&type=script&lang=js&"
export * from "./GallerySection.vue?vue&type=script&lang=js&"
import style0 from "./GallerySection.vue?vue&type=style&index=0&id=f2255040&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2255040",
  null
  
)

export default component.exports